import React, { useEffect, useRef, useState, useCallback } from "react";
import { ApiService } from "../../Components/Services/apiservices";
import { Swiper, SwiperSlide } from "swiper/react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { BrowserView, MobileView } from "react-device-detect";
import ProductBox from "./product_box";

function TagWiseProducts({ indexLoop, onParentData, dataObj }) {
  const didMountRef = useRef(true);
  const tagsRef = useRef(null);
  const taghandlePrev = useCallback(() => {
    if (!tagsRef.current) return;
    tagsRef.current.swiper.slidePrev();
  }, []);

  const taghandleNext = useCallback(() => {
    if (!tagsRef.current) return;
    tagsRef.current.swiper.slideNext();
  }, [])
  const [loading, setLoading] = useState();

  const [tagCategoriesData, setTagCategoriesData] = useState([]);
  useEffect(() => {
    if (didMountRef.current) {
      getTagCategoryData();
    }
    didMountRef.current = false;
  }, []);
  const getTagCategoryData = () => {
    setLoading(true);
    const dataString = {
      data: dataObj,
    };
    ApiService.postData("tags-wise-products-new", dataString).then((res) => {
      if (res.status == "success") {
        setTagCategoriesData(res.tagsData);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };
  return (
    <>
      {loading == true ? (
        <>
          <BrowserView>
            <div className="row g-2">
              {[...Array(4)].map((_, index) => (
                <div key={index} className="col-lg-3 col-6">
                  <div className="product">
                    <figure className="product-media">
                      <Skeleton variant="text" width={300} height={250} />
                    </figure>
                    <div className="product-details">
                      <h3 className="product-name">
                        <Skeleton variant="text" width={150} />
                      </h3>
                      <div className="product-price">
                        <Skeleton variant="text" width={150} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </BrowserView>
          <MobileView>
            <div className="row g-2">
              {[...Array(4)].map((_, index) => (
                <div key={index} className="col-lg-3 col-6">
                  <div className="product">
                    <figure className="product-media">
                      <Skeleton variant="text" width={300} height={160} />
                    </figure>
                    <div className="product-details">
                      <h3 className="product-name">
                        <Skeleton variant="text" width={150} />
                      </h3>
                      <div className="product-price">
                        <Skeleton variant="text" width={150} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </MobileView>
        </>
      ) : (
        <>
          {tagCategoriesData.map((value, index) => {
            if (value.tagProducts.length > 0) {
              if (dataObj.home_display_type === 2) {
                return (
                  <>
                    <div className="page-title mb-4" key={index}>
                      <h2 className="mb-0">{dataObj.home_product_name}</h2>
                      <a href={"/collection/tag/" + value.tag_slug} className="viewmorebutton">View More <i className="ri-arrow-right-s-line ms-2"></i></a>
                    </div>
                    <div className={"row g-3 " + dataObj.home_col_grid + dataObj.home_column}>
                      {value.tagProducts.map((subvalue, indexProduct) => {
                        return (
                          <>
                            <ProductBox productValue={subvalue} indexProduct={indexProduct} key={indexProduct} />
                          </>
                        );
                      })}
                    </div>
                  </>
                );
              } else {
                return (
                  <>
                    <div className="page-title mb-4" key={index}>
                      <h2 className="mb-0">{dataObj.home_product_name}</h2>
                      <a href={"/collection/tag/" + value.tag_slug} className="viewmorebutton">View More <i className="ri-arrow-right-s-line ms-2"></i></a>
                    </div>
                    <div className="productSlider">
                      <Swiper
                        loop={true}
                        spaceBetween={15}
                        navigation={{
                          nextEl: ".swiper-button-next",
                          prevEl: ".swiper-button-prev",
                        }}
                        breakpoints={{
                          0: {
                            slidesPerView: dataObj.home_column,
                          },
                          600: {
                            slidesPerView: dataObj.home_column,
                          },
                          1000: {
                            slidesPerView: dataObj.home_column,
                          },
                        }}
                        ref={tagsRef}

                      >
                        {value.tagProducts.map((subvalue, indexProduct) => {
                          return (
                            <SwiperSlide key={indexProduct}>
                              <ProductBox productValue={subvalue} indexProduct={indexProduct} key={indexProduct}/>
                            </SwiperSlide>
                          );
                        })}
                      </Swiper>
                      <div className='swip-buttons'>
                        <div className="swip-button swip-button-prev" style={{ alignItems: 'center' }} onClick={taghandlePrev} >
                          <span>
                            <i className="ri-arrow-left-line"></i>
                          </span>

                        </div>
                        <div className="swiper-button swip-button-next" onClick={taghandleNext} style={{ alignItems: 'center' }}>
                          <span>
                            <i className="ri-arrow-right-line"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                );
              }
            }
          })}
        </>
      )}
    </>
  );
}
export default TagWiseProducts;
